import React, { useContext, useState } from 'react'
import useTranslation from '../../hooks/useTranslation';
import { CompactFeedbackForm } from './FeedbackForms/FeedbackForms'
import { Like } from '../icons/Icons';
import './GiveFeedbackButton.scss'

/**
 *
 * @param {Object} props
 * @param {string=} props.className
 * @param {boolean=} props.stickRight
 * @param {any=} props.executeRecaptcha
 */
function GiveFeedbackButton(props) {
  const { className = '', stickRight, executeRecaptcha } = props
  const [isOpen, setIsOpen] = useState(false)
  const t = useTranslation()

  return (
    <>
      <div
        data-testid="GiveFeedbackButton"
        onClick={() => setIsOpen((prev) => !prev)}
        className={`GiveFeedbackButton ${stickRight ? 'stick-right' : ''} ${className} ${isOpen ? 'opened' : ''}`}
      >
        <div className="button-icon">
          <Like size={30}/>
        </div>
        <div className="button-text">{t('ui-feedback-button-text')}</div>
      </div>
      {isOpen && (
        <div className={`CompactFeedbackFormContainer ${stickRight ? 'stick-right' : ''}`}>
          <CompactFeedbackForm onClose={() => setIsOpen(false)} executeRecaptcha={ executeRecaptcha}  />
        </div>
      )}
    </>
  )
}

export default GiveFeedbackButton
